import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Target, Activity, UserRound, Shield, ArrowRight } from "lucide-react";

const iconMap = { Target, Activity, UserRound, Shield };

export default function Wealth({ onContact }) {
  const wealth = useContent().wealth;
  return (
    <section id="vermoegen" className="py-20 lg:py-28 bg-[#16233d] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden">
            <img src={wealth.image} alt="Vermögensverwaltung" className="w-full h-[480px] object-cover" />
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <div className="eyebrow mb-4" style={{ color: "#d3b077" }}>{wealth.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl font-semibold leading-tight">{wealth.title}</h2>
          <p className="mt-5 text-white/70 text-lg leading-relaxed">{wealth.text}</p>

          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-7 mt-9">
            {wealth.items.map((it) => {
              const Icon = iconMap[it.icon];
              return (
                <div key={it.title}>
                  <div className="flex items-center gap-3 mb-2">
                    <Icon size={20} className="text-[#d3b077]" />
                    <h3 className="font-serif-lux text-xl">{it.title}</h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">{it.text}</p>
                </div>
              );
            })}
          </div>

          <button onClick={onContact} className="btn-gold rounded-md px-6 py-3.5 font-medium mt-10 inline-flex items-center gap-2">
            {wealth.cta} <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </section>
  );
}
